import { toastr } from 'react-redux-toastr'
import * as ActionTypes from '../../actions/actionTypes'
import * as actions from '../../actions/hotels24actions'
import { getParser } from '../../adapters'
import { urlParams } from '../../utils/mainUtils'
import { handleError, handleResponse, securedFetch, showImportCategoriesToastr } from '../apiUtils'
import * as urls from '../urls'

/** @thunk **/
export const fetchH24Categories = params => (dispatch, getState) => {
    dispatch({ type: ActionTypes.H24_CATEGORIES_FETCH_REQUEST })
    const { auth } = getState()

    securedFetch(urlParams(urls.h24CategoriesFind, params), auth, { method: 'GET' })
        .then(handleResponse)
        .then(json => dispatch(actions.h24_fetchCategoriesSuccess(getParser(urls.h24Categories)(json))))
        .catch(
            handleError(
                dispatch,
                actions.h24_fetchCategoriesFailure,
                'Что-то пошло не так!',
                'При получении категорий произошла ошибка'
            )
        )
}

/** @thunk **/
export const postH24Category = category => (dispatch, getState) => {
    const opts = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(category)
    }
    const { auth } = getState()

    securedFetch(urls.h24Categories, auth, opts)
        .then(handleResponse)
        .then(json => dispatch(actions.h24_saveCategoriesSuccess(json)))
        .then(() => toastr.success('Категория успешно сохранена'))
        .catch(
            handleError(
                dispatch,
                actions.h24_saveCategoriesFailure,
                'Что-то пошло не так!',
                'При сохранении категорий произошла ошибка'
            )
        )
}

/** @thunk **/
export const deleteH24Category = remoteId => (dispatch, getState) => {
    const { auth } = getState()
    securedFetch(urls.h24CategorySelf(remoteId), auth, { method: 'DELETE' })
        .then(handleResponse)
        .then(() => dispatch(actions.h24_deleteCategorySuccess(remoteId)))
        .then(() => toastr.success('Категория удалена'))
        .catch(
            handleError(
                dispatch,
                actions.h24_deleteCategoryFailure,
                'Что-то пошло не так!',
                'При удалении категории произошла ошибка'
            )
        )
}

/** @thunk **/
export const importH24Categories = () => (dispatch, getState) => {
    const { auth, h24CurrentOrganization } = getState()

    const opts = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ organizationId: h24CurrentOrganization })
    }

    securedFetch(urls.reloadCategoriesFromH24, auth, opts)
        .then(handleResponse)
        .then(showImportCategoriesToastr)
        .then(json => dispatch(actions.h24_importCategoriesSuccess(getParser(urls.reloadCategoriesFromH24)(json))))
        .catch(
            handleError(
                dispatch,
                actions.h24_importCategoriesFailure,
                'Что-то пошло не так!',
                'При импорте категорий произошла ошибка'
            )
        )
}



// WEBPACK FOOTER //
// ./src/api/h24Api/h24Categories.js